import { CheckCircle, XCircle, X } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

interface SubmissionAlertProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
}

export const SubmissionAlert = ({ type, message, onClose }: SubmissionAlertProps) => {
  return (
    <Alert className={`mb-4 ${type === 'success' ? 'border-green-500 bg-green-50' : 'border-red-500 bg-red-50'}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {type === 'success' ? (
            <CheckCircle className="h-4 w-4 text-green-600" />
          ) : (
            <XCircle className="h-4 w-4 text-red-600" />
          )}
          <AlertDescription className={type === 'success' ? 'text-green-800' : 'text-red-800'}>
            {message}
          </AlertDescription>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="h-6 w-6 p-0 hover:bg-transparent"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </Alert>
  );
};